module.exports = __webpack_public_path__ + "img/new-wipple.87f155b5.png";